import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Tooltip,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  TextField,
  Paper,
  Box,
  IconButton,
  FormControlLabel,
  Button,
  ButtonGroup,
  Checkbox,
  Tab,
} from "@material-ui/core";
import {TabContext, TabList, TabPanel} from '@material-ui/lab';

import clsx from "clsx";

import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import {getPlansByUser, getPlan, getPlans, setPlanDraft, approvePlan, rejectPlan} from "../../../actions/fallProtectionAction";
import Feedback from "../../../utils/Feedback";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  title: {
    fontSize: 13,
  },
  title2: {
    fontSize: 13,
    marginBottom: 10,
    fontWeight: "bold",

    },

  time: {
    // marginLeft: "auto",
    marginTop: 10,

    // width: 120,
    width: "fit-content",
    height: 40,
    padding: theme.spacing(1),
    // textAlign: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
  btnLink: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    width: 200,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },

  btnGroup: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
  },
  
  dialog: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },
  formControl: {
      minWidth: 380,
      [theme.breakpoints.down("sm")]: {
          width: "100%",
      },
      [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
      },
  },
  formcontrol2: {
    textAlign: "left",
    minWidth: 350,
    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
      width: "100%",
  },
  [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
  },
  
  typo : {
    fontWeight: "bold",
    fontSize: 13,
  },
  statusDarkGreen: {
    borderColor: "#4caf50",
    color: "#4caf50",
  },
  statusDarkRed: {
    borderColor: "#f44336",
    color: "#f44336",
  },
  paper3:{
    textAlign: "center",
    width: "fit-content",
    height: 50,
    display: "flex",
    justifyContent: "center",
    marginTop: 30
  },
  leftAlign: {
    textAlign: "left",
  },
  sign : {
    width: 60,
    height: 30,
    [theme.breakpoints.down("sm")]: {
      width: 60,
      height: 30,
    },
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 20,
    },
  },

  sketch : {
    width: 500,
    height: 400,
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: 400,
      height: 200,
    },
  },

}));

const INIT_STATE = {
  planner: "",
  ert: "",
  supervisor: undefined,
  safety:"",
  date: "",
  location: undefined,
  radio: false,
  cell:false,
  verbal:false,
  meetingPoint: "",
  personToSecure: "",
  personnelTrained: "",
  readiness: "",
  awp: false,
  ladder: false,
  scaffold: false,
  crane: false,
  other: false,
  otherDescription: "",
  haveAlternative: false,
  workersTrained: false,
  equipmentAppropriate: false,
  discussedWithCrew: false,
  equipmentInspected: false,
  traumaStraps: false,
  workerFallPlan: "",
  workArea: "",
  reviews: [{ name: "", signature: "", date: "" }],
  error: null,
  success: false,
  loading: false,
};

const ViewPlanModal = ({ openViewPlan, handleCloseViewPlan, id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { fallProtection, error, loading } = useSelector((state) => state.fallprotection);
  const { profile, locations, users } = useSelector((state) => state.users);
  const [val, setVal] = useState("1");


    let isAdminGuard = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("admin"))
    : false;

    let isFallAdmin = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("fall_admin"))
        : false;


useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
        setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
        }));
    }
    return () => {
        abortController.abort();
    };
    }, [error]);

  useEffect(() => {
    if (id){
      dispatch(getPlan(id));
    }
  }, [dispatch, id]);
 
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      planner: fallProtection?.planner,
      ert: fallProtection?.ert,
      supervisor: fallProtection?.supervisor,
      safety: fallProtection?.safety,
      date: fallProtection?.date,
      location: fallProtection?.location?.displayname,
      radio: fallProtection?.radio,
      cell: fallProtection?.cell,
      verbal: fallProtection?.verbal,
      meetingPoint: fallProtection?.meetingPoint,
      personToSecure: fallProtection?.personToSecure,
      personnelTrained: fallProtection?.personnelTrained,
      readiness: fallProtection?.readiness,
      awp: fallProtection?.awp,
      ladder: fallProtection?.ladder,
      scaffold: fallProtection?.scaffold,
      crane: fallProtection?.crane,
      other: fallProtection?.other,
      otherDescription: fallProtection?.otherDescription,
      haveAlternative: fallProtection?.haveAlternative,
      workersTrained: fallProtection?.workersTrained,
      equipmentAppropriate: fallProtection?.equipmentAppropriate,
      discussedWithCrew: fallProtection?.discussedWithCrew,
      equipmentInspected: fallProtection?.equipmentInspected,
      traumaStraps: fallProtection?.traumaStraps,
      workerFallPlan: fallProtection?.workerFallPlan,
      workArea: fallProtection?.workArea,
      reviews: fallProtection?.reviews,

    }));
  }, [fallProtection]);

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const handleTabChange = (event, newVal) => {
    setVal(newVal);
  };

  const handleSetDraft = (e) => {
    e.preventDefault();
    dispatch(setPlanDraft(id));
    setTimeout(() => {
      handleCloseViewPlan();
        dispatch(getPlans());
        dispatch(getPlansByUser());

        setFeed((prev) => ({
          loading: false,
          open: true,
          message: "Plan set to draft successfully!",
          success: true,
        }));
    }, 1500);
  };
  
  const handleApprove = (e) => {
    e.preventDefault();
    dispatch(approvePlan(id));
    setTimeout(() => {
      handleCloseViewPlan();
        dispatch(getPlans());
        dispatch(getPlansByUser());

        setFeed((prev) => ({
          loading: false,
          open: true,
          message: "Plan approved successfully!",
          success: true,
        }));
    }, 1500);
  }

  const handleReject = (e) => {
    e.preventDefault();
    dispatch(rejectPlan(id));
    setTimeout(() => {
      handleCloseViewPlan();
        dispatch(getPlans());
        dispatch(getPlansByUser());

        setFeed((prev) => ({
          loading: false,
          open: true,
          message: "Plan rejected successfully!",
          success: true,
        }));
    }, 1500);
  }

  return (
    <div>
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Dialog
        open={openViewPlan}
        onClose={handleCloseViewPlan}
        fullWidth
        maxWidth="md"
        className={classes.dialog}

      >
        <DialogTitle>
        
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                View Fall Protection Rescue/Assist Plan
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseViewPlan}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} sm={12}>
              <ButtonGroup className={classes.btnGroup} variant="outlined">
                {fallProtection && (fallProtection.status === "Submitted") && (isAdminGuard || isFallAdmin) && (
                  <>
                    <Button
                        size="small"
                        className={clsx(classes.btnLink, classes.statusDarkGreen)}
                        onClick={handleApprove}
                    >
                        Approve Plan
                    </Button>
                    <Button
                        size="small"
                        className={clsx(classes.btnLink, classes.statusDarkRed)}
                        onClick={handleReject}
                    >
                        Reject Plan
                    </Button>
                  </>
                )}
                {fallProtection && (fallProtection.status === "Submitted" || fallProtection.status === "Approved" || fallProtection.status === "Rejected") && (isAdminGuard || isFallAdmin) && (
                  <Button
                      size="small"
                      className={classes.btnLink}
                      color="primary"
                      onClick={handleSetDraft}
                  >
                      Set to Draft
                  </Button>
                )}
              </ButtonGroup>
            </Grid>
          </Grid>
              
          <br/>   
          <Divider />

        <DialogContent className={classes.dialogContent}>
        <Paper className={classes.paper} variant="outlined">
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={val}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleTabChange} textColor="secondary" indicatorColor="secondary">
                      <Tab label="Plan Information" className={classes.tab} value="1"/>
                      <Tab label="Sketch/Sign"  className={classes.tab} value="2"/>
                      </TabList>
                  </Box>
                  <TabPanel value="1">
                      <Grid container justifyContent="center" alignItems="center" spacing={3}>
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  name="date"
                                  fullWidth
                                  variant="outlined"
                                  label="Date"
                                  value={state.date?.split("T")[0] || ""}
                                  disabled
                              />
                          </Grid>
                          <Grid item xs={12} sm={6} >
                              <TextField
                                name="location"
                                fullWidth
                                variant="outlined"
                                label="Location"
                                value={state.location || ""}
                                disabled    
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Contacts</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    name="planner"
                                    fullWidth
                                    variant="outlined"
                                    label="Planner"
                                    value={state.planner}
                                    disabled
                                />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="ert"
                                      fullWidth
                                      variant="outlined"
                                      label="ERT"
                                      value={state.ert || ""}
                                      disabled
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                    name="supervisor"
                                    fullWidth
                                    variant="outlined"
                                    label="Supervisor"
                                    value={state.supervisor?.displayname || ""}
                                    disabled
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="safety"
                                      fullWidth
                                      variant="outlined"
                                      label="Safety"
                                      value={state.safety || ""}
                                      disabled
                                  />
                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Personnel Roles</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    name="meetingPoint"
                                    fullWidth
                                    variant="outlined"
                                    label="Meeting Point"
                                    value={state.meetingPoint || ""}
                                    disabled
                                />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="personToSecure"
                                      fullWidth
                                      variant="outlined"
                                      label="Person to Secure the Area"
                                      value={state.personToSecure || ""}
                                      disabled
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="personnelTrained"
                                      fullWidth
                                      variant="outlined"
                                      label="Personnel Trained on AWP"
                                      value={state.personnelTrained || ""}
                                      disabled
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="readiness"
                                      fullWidth
                                      variant="outlined"
                                      label="Location/Readiness of AWP (Keys, Fuel, etc.)"
                                      value={state.readiness || ""}
                                      disabled
                                  />
                                </Grid>

                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Method of Communication</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.radio || false}
                                        name="radio"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Radio"
                                    labelPlacement="end"
                                />      
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.cell || false}
                                        name="cell"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Cell"
                                    labelPlacement="end"
          
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.verbal || false}
                                        name="verbal"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Verbal"
                                    labelPlacement="end"
                                />       
                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Rescue Equipment</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.awp || false}
                                        name="awp"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="AWP"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.ladder || false}
                                        name="ladder"
                                        color="primary"
                                       disabled
                                    />
                                    }
                                    label="Ladder"
                                    labelPlacement="end"
                                />      
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.scaffold || false}
                                        name="scaffold"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Scaffold"
                                    labelPlacement="end"
                                />
                                
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.crane || false}
                                        name="crane"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Crane"
                                    labelPlacement="end"
                                />
                                
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.other || false}
                                        name="other"
                                        color="primary"
                                        disabled
                                    />
                                    }
                                    label="Other"
                                    labelPlacement="end"
                                />
                              
                                {state.other && (
                                  <TextField
                                      name="otherDescription"
                                      fullWidth
                                      variant="outlined"
                                      label="Other Description"
                                      value={state.otherDescription || ""}
                                      disabled
                                  />
                                )}

                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Pre Work Tasks</h3>
                              </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.haveAlternative || false}
                                    name="haveAlternative"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Have alternatives to using fall protection equipment been considered?"
                                labelPlacement="end"
                            />
                            </Grid>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.workersTrained || false}
                                    name="workersTrained"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Are all workers trained in fall protection (2 day WHSCC approved)?"
                                labelPlacement="end"
                            />      
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.equipmentAppropriate || false}
                                    name="equipmentAppropriate"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Is fall protection equipment appropriate for the job (100% tie off, painter's harness/lanyard, welder's harness/lanyard)?"
                                labelPlacement="end"
                            />
                            
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.discussedWithCrew || false}
                                    name="discussedWithCrew"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Have you discussed with the crew how you are planning to rescue a co-worker/self-rescue?"
                                labelPlacement="end"
                            />
                            
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.equipmentInspected || false}
                                    name="equipmentInspected"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Has fall protection equipment been inspected?"
                                labelPlacement="end"
                            />

                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.traumaStraps || false}
                                    name="traumaStraps"
                                    color="primary"
                                    disabled
                                />
                                }
                                label="Does each harness have 2 trauma straps in good condition, are workers familiar with them?"
                                labelPlacement="end"
                            />

                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                              <TextField
                                  name="workerFallPlan"
                                  fullWidth
                                  variant="outlined"
                                  label="Brief Description of Your Plan if a Worker Falls (Assisted or Self Rescue)"
                                  value={state.workerFallPlan || ""}
                                  multiline
                                  minRows={6}
                                  disabled
                              />
                            </Grid>
                          
                      </Grid>
                      <br />
                      
                  </TabPanel>
                  <TabPanel value="2">
                    <Grid container justifyContent="center" alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Paper className={classes.paper} variant="outlined" square>
                                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                                  
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle2" align="center">
                                            Sketch Your Work Area and How You Will Self Rescue
                                        </Typography>
                                        <br />
                                        <Grid item xs={12} sm={12}>
                                            <img src={state.workArea} alt="sketch" className={classes.sketch} />
                                        </Grid>
                                        <br />  

                                    </Grid>
                    
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>

                    <br />

                    {state.reviews && state.reviews?.length > 0 && (
                    <Grid item xs={12} sm={12}>
                        <Paper className={classes.paper} variant="outlined" square>
                            {state.reviews?.map((item, index) => (
                            <Grid container justifyContent="center" alignItems="center" spacing={2} key={index}>
                              <Grid item xs={6} sm={6} md={6}>
                                <TextField
                                    name="name"
                                    fullWidth
                                    variant="outlined"
                                    label="Name"
                                    value={item.name}
                                    size="small"
                                    disabled
                                />
                              </Grid> 
                                <Grid item xs={3} sm={3} md={3}>
                                  <img src={item.signature} alt="signature" className={classes.sign} />
                                </Grid>
                                <Grid item xs={3} sm={3} md={3}>
                                  <TextField
                                    name="date"
                                    fullWidth
                                    variant="outlined"
                                    label="Date"
                                    value={item.date?.split("T")[0] || ''}
                                    size="small"
                                    disabled 
                                  />
                              </Grid>   

                            </Grid>
                            ))}
    
                        </Paper>
                    </Grid>
                    )}
                    <br />
                      
                  </TabPanel>
              </TabContext>
            </Box>
          </Paper>

        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ViewPlanModal;
